<template>
  <span :class="['inline-flex items-center rounded px-2 py-0.5 font-medium whitespace-nowrap', style]">{{ text }}</span>
</template>

<script>
import { STATUS_STYLE, words } from './hermes';

export default {
  name: 'HermesBadge',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
  },
  computed: {
    style() {
      return STATUS_STYLE[this.value] || 'bg-gray-100 text-gray-800';
    },
    text() {
      const t = this.label || words(this.value);
      return t.charAt(0).toUpperCase() + t.slice(1);
    },
  },
};
</script>
